"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMessages = void 0;
exports.defaultMessages = {
    tos: "Terms of Service",
    privacy: "Privacy Policy",
    backToTop: "Back to top",
};
//# sourceMappingURL=defaultMessages.js.map